import { END } from "@angular/cdk/keycodes";
import { sign } from "crypto";

export const URL = {
    ACCOUNT: {
        LOGIN: '/authenticate/1.1.0',
        REFRESH_TOKEN: '/refresh-token',
        LOGOUT: '/logout',
        FORGOT_PWD: '/notifyPasswordReset',
        RESET_PWD: '/resetPassword',
        CHANGE_PWD: '/changePassword',
        EMAIL_SERVICE: '/demo-request',
        CONTACT_SERVICE: '/contact-message',
        MENU: '/getMenus',
        GET_USER_ORG_LIST: '/getUserOrgList',
        LOGIN_WITH_ORG: '/loginWithOrg',
        GET_SUBSCRIBED_FEATURES_BY_ORG_ID: '/getSubscribedFeatures',
        IS_SYSTEM_SUPER_ADMIN: '/is-system-super-admin',
        GET_ORG_FOR_PASS: '/getOrgListForResetPass',
        SAVE_CONSENT: '/user-consent/save'
    },
    ADMIN: {
        SEND_SMS: "/notifications/send_sms",
        SEND_EMAIL: "/notifications/send_email",
        LIST_ORGS: '/getAllOrgs',
        GET_ALL_MODULES: '/getAllModules',
        GET_ALL_COURSE_FRAMEWORKS: '/getAllCourseFrameworks',
        GET_ALL_STATES: '/getAllStatesAndDistricts',
        GET_ALL_VERTICALS: '/getAllIndVerticals',
        GET_ORG_BY_ID: '/getOrgById',
        GET_ADMIN: '/getAdmin',
        GET_ALL_MOUS: '/getAllMou',
        GET_ALL_SUBSCRIPTION_PLANS: '',
        GET_FEATURES_BY_PLAN: '/getFeaturesByPlan',
        CREATE_SUBSCRIPTION_PLAN: '/createSubscriptionPlan',
        UPDATE_SUBSCRIPTION_PLAN: '/updateSubscriptionPlan',
        CHECK_PLAN_ORG_LINKS: '/checkPlanOrgLinks',
        DELETE_SUBSCRIPTION_PLAN: '/deleteSubscriptionPlan',
        GET_PLAN_BY_ORG_ID: '/getPlanByOrgId',
        SAVE_PLAN_BY_ORG_ID: '/savePlanByOrgId',
        CREATE_OR_UPDATE_ORG: '/createOrUpdateOrg',
        CREATE_UPDATE_ADMIN: '/addOrEditAdmin',
        UPDATE_ORG_STATUS: '/updateStatus/orgStatus',
        UPDATE_ADMIN_STATUS: '/updateStatus/adminStatus',
        UPDATE_ORG_ADMIN_STATUS: '/updateStatus/orgAdminStatus',
        GET_ALL_ADMIN_ROLES: '/getAllAdminRoles',
        GET_ADMIN_ROLE: '/getAdminRole',
        UPDATE_ADMIN_ROLE_STATUS: '/updateStatus/adminRoleStatus',
        UPDATE_ADMIN_ROLE_PERMISSIONS: '/updateStatus/adminRolePermissions',
        GET_ALL_USER_CATEGORIES: '/getAllUserCategories',
        UPDATE_USER_CATEGORY_STATUS: '/updateStatus/userCategory',
        GET_CATEGORY_ATTRIBUTES_ID: '/getCategoryAttributesById',
        GET_ALL_ORG_USERS: '/getAllOrgUsers',
        GET_ORG_USERS_PAGINATED: '/orgUsersPaginated',
        UPDATE_USER_STATUS: '/updateStatus/user',
        SAVE_LOGIN_CREDENTIALS: '/saveUserLoginCredentials',
        SEND_VERIFICATION_EMAIL: '/sendVerificationEmail',
        GET_EMAIL_VERIFICATION_STATUS: '/getEmailVerificationStatus',
        VERIFY_EMAIL_BY_TOKEN: '/verifyEmailByToken',
        RESEND_VERIFICATION_EMAIL: '/resendVerificationEmail',
        CHECK_DUPLICATE_EMAIL: '/checkDuplicateEmail',
        GET_CUST_ATTR_VALUES_BY_ID: '/getCustAttrValuesById',
        GET_ALL_INDUSTRY_VERTICALS: '/getAllIndustryVerticals',
        UPDATE_INDUSTRY_VERTICAL_STATUS: '/updateStatus/industryVertical',
        GET_ALL_BUSINESS_VERTICALS: '/getAllBusinessVerticals',
        UPDATE_BUSINESS_VERTICAL_STATUS: '/updateStatus/businessVertical',
        GET_ALL_PRODUCTS: '/getAllOrgProducts',
        UPDATE_PRODUCT_STATUS: '/updateStatus/product',
        GET_TAGS_BY_ORG_ID: '/getTagsByOrgId',
        CREATE_UPDATE_TAG: '/addOrEditTag',
        SEARCH_TAG: '/searchLevel3',
        DOWNLOAD_SAMPLE_FILE: '/bulk-upload/sampleFile',
        UPLOAD_FILE: '/bulk-upload',
        UPLOAD_FILES: '/upload',
        UPLOAD_QUESTION_IMAGES_ZIP: '/bulk-upload/question-images',
        DOWNLOAD: '/download',
        DOWNLOAD_ATTACHMENT: '/download-attachment',
        signedUrl: '/signed-urls',
        EXPENSE_TYPE: '/expense-type',
        COST_CATEGORY: '/cost-category',
        REVISON_HISTORY: '/getRevisionHistory',
        RESOURCES_DATA: '/getResourcesData',
        OPERATIONS_DATA: '/getOperationsData',
        GEOGRAPHY_DATA: '/getGeography',
        COURSES_MASTER: '/getCoursesMasterData',
        LANGUAGES_MASTER: '/getLanguagesMasterData',
        CUSTOMERS_MASTER: '/getSalesCustomerMasterData',
        SALES_DATA: '/getSalesData',
        CONTENTS_DATA: '/getContentsData',
        FINANCES_DATA: '/getFinancesData',
        CONSOLIDATED_DASHBOARD_DATA: '/getConsolidatedDashboardData',
        CATEGORIES_FILTERS: '/getQuestionCategoryFilters',
        GET_ALL_PRODUCT: '/getall/product'
    },
    SALES: {
        CREATE_UPDATE_LEAD: '/addOrEditSalesLead',
        CREATE_UPDATE_CONTACT: '/addOrEditContact',
        GET_ALL_LEADS: '/getAllSalesLead',
        GET_LEAD_DETAILS: '/getSalesLeadDetails',
        GET_OPPORTUNITY_COUNTS: '/getSalesOpportunityCounts',
        GET_OPPORTUNITY_DETAILS: '/getSalesOpportunityDetails',
        GET_OPPORTUNITY_LIST: '/getSalesOpportunityList',
        UPDATE_OPPORTUNITY_STATUS: '/updateStatus/opportunityStatus',
        GET_CUSTOMER_COUNTS: '/getSalesCustomerCounts',
        GET_CUSTOMER_OPPORTUNITY_LIST: '/getSalesCustomerOpportunityList',
        GET_OPPORTUNITY_MOU_LIST: '/getSalesOpportunityMouList',
        GET_OPPORTUNITY_MOU_DETAILS: '/getSalesOpportunityMouDetails',
        UPDATE_CUSTOMER_STATUS: '/updateStatus/salesCustomerStatus',
        UPDATE_REASON_FOR_DROPPING: '/updateStatus/reasonForDropping',
        GET_CUSTOMER_SPOCS_LIST: '/getCustomerSpocsList',
        GET_CUSTOMER_DETAILS: '/getSalesCustomerDetails',
        GET_ACCOUNT_MANAGERS: '/getSalesAccountManagers',
        GET_CUSTOMER_GROUPS: '/getSalesCustomerGroups',
        GET_CUSTOMER_GROUPS_CUSTOMERS: '/getSalesCustomerGroupsCustomers',
        UPDATE_LEAD_STATUS: '/updateStatus/updateSalesLeadStatus',
        CREATE_UPDATE_CUSTOMER: '/addOrEditSalesCustomer',
        CREATE_UPDATE_CUSTOMER_GROUPS: '/addOrEditCustomerGroups',
        CREATE_UPDATE_SCHEME: '/addorEdit/salesScheme',
        UPLOAD_SALES_LEADS_DATA: '/uploadSalesLeadsData',
        LEADS: '/leads',
        CONTACT: '/contact',
        OPPORTUNITY: '/opportunity',
        CUSTOMERS: '/customers'
    },
    CONTENT: {
        CONTENT_LABEL: '/content-label',
        GET_QUESTION_PAPER_DETAIL: "/question_paper_detail",
        GET_COURSE_FRAMEWORK: '/getCourseFrameWork',
        GET_COURSE_FRAMEWORK_LABELS: '/getCourseFrameworkLabels',
        GET_ALL_COURSE_GROUPS: '/getAllCourseGroups',
        UPDATE_COURSE_GROUP_STATUS: '/updateStatus/courseGroup',
        GET_COURSE_FRAMEWORK_BY_ORG_ID: '/getCourseFrameworksByOrgId',
        URL_META_DATA: '/getUrlMetaData',
        GET_ALL_COURSE_VERSIONS: '/getAllCourseVersions',
        GET_ALL_COURSE_MODULES: '/getAllCourseModules',
        GET_ALL_COURSE_TOPICS: '/getAllCourseTopics',
        GET_ALL_COURSES: '/getAllCourses',
        CREATE_UPDATE_COURSE_GROUP: '/addOrEditCourseGroup',
        DELETE_COURSE_GROUP: '/delete/deleteCourseGroup',
        CREATE_UPDATE_COURSE_SUB_GROUP: '/addOrEditCourseSubGroup',
        GET_ALL_COURSE_SUB_GROUPS: '/getAllcourseSubGroups',
        UPDATE_COURSE_SUB_GROUP_STATUS: '/updateStatus/courseSubGroup',
        CREATE_UPDATE_COURSE_TOPIC: '/addOrEditCourseTopic',
        GET_ALL_COURSE_LEVEL2_LIST: '/getCourseLevel2',
        INSERT_UPDATE_COURSE_LEVEL2_LIST: '/saveOrUpdatecourseLevel2',
        UPDATE_COURSE_VERSION_STATUS: '/updateStatus/courseVersionStatus',
        UPDATE_COURSE_MODULE_STATUS: '/updateStatus/courseModuleStatus',
        UPDATE_COURSE_TOPIC_STATUS: '/updateStatus/courseTopicStatus',
        UPDATE_COURSE_LEVEL3_STATUS: '/updateStatusLevel3',
        DELETE_COURSE_VERSION_BY_ID: '/deleteCourseVersionById',
        DELETE_COURSE_LEVEL1_BY_ID: '/deleteCourseLevel1',
        DELETE_COURSE_LEVEL2_BY_ID: '/deleteCourseLevel2',
        DELETE_COURSE_LEVEL3_BY_ID: '/deleteCourseLevel3',
        UPDATE_COURSE_STATUS: '/updateStatus/courseStatus',
        DOWNLOAD_COURSE: '/downloadCourse',
        ASSESSMENT_METHODOLOGY_LIST: '/getAssessmentMethodologyList',
        CREATE_UPDATE_QUESTION_BANK: '/addOrEditQuestionBank',
        CREATE_UPDATE_QUESTION_PAPER: '/addOrEditQuestionPaper',
        CREATE_UPDATE_QUESTION_LABELS: '/content-label/questionsLabelUpdate',
        QUESTION_COURSE_MODULE_MAPPING: '/getQuestionCourseModuleMapping',
        SAVE_QUESTION_COURSE_MODULE_MAPPING: '/saveQuestionCourseModuleMapping',
        UPDATE_QUESTION_COURSE_MODULE_MAPPING: '/updateQuestionCourseModuleMapping',
        SAVE_OPTIONS_DATA: '/saveOptionsData',
        SAVE_FILL_IN_THE_BLANK: '/saveFillInTheBlankData',
        SAVE_MATCH_THE_FOLLOWINGS: '/saveMatchTheFollowingData',
        SAVE_SUBJECTIVE_ANSWER_DATA: '/saveSubjectiveAnswerData',
        GET_QUESTION_BANK_LIST: '/getQuestionBankList',
        UPDATE_QUESTION_BANK_STATUS: '/updateQuestionBankStatus',
        UPDATE_QUESTION_PAPER_STATUS: '/updateQuestionPaperStatus',
        REVERT_QUESTION_PAPER_VERSION: '/revertQuestionPaperVersion',
        COMPARE_QUESTION_PAPER_VERSIONS: '/compareQuestionPaperVersions',
        DELETE_QUESTION_BANK: '/deleteQuestionBank',
        DELETE_QUESTION: '/deleteQuestion',
        SAVE_KPI: '/saveKpiData',
        DELETE_KPI: '/deleteKpiData',
        LANGUAGE_LIST: '/questionLanguage',
        LANGUAGE: '/languages',
        SAVE_RUBRIC_DATA: '/saveOrUpdateRubric',
        DELETE_RUBRIC: '/deleteRubric',
        DELETE_MATCHING_LIST: '/saveMatchTheFollowingData',
        SCENARIO_BASED_QUESTION_MAPPING: '/scenarioBasedQuestionMapping',
        GET_RUBRIC_LIST: '/getRubricList',
        CONTENT_FILE_UPLOAD: '/fileUploadContent',
        GET_QUESTION_PAPER_LIST: '/getQuestionPaperList',
        DELETE_QUESTION_PAPER: '/deleteQuestionPaper',
        GET_QUESTION_PAPER_VERSION_BY_ID: '/getQuestionPaperVersionById',
        GET_QUESTION_PAPER_VERSION_LIST: '/get/questionPaperVersionList',
        ADD_EDIT_QUESTION_PAPER_VERSION: '/addoredit/questionPaperVersion',
        DELETE_QUESTION_PAPER_VERSION: '/delete/deleteQuestionPaperVersion',
        UPDATE_STATUS_QUESTION_PAPER_VERSION: '/updateStatus/questionPaperVersion',
        UPDATE_QUESTION_PAPER_EVALUATION_STATUS: '/updateStatus/questionPaperEvaluation',
        GET_QUESTIONS_MANUAL_IMPORT: '/questions/manual-import',
        QUESTION_PAPER_AS_DRAFT: '/questions/paper-mappings',
        GET_PUBLISHED_QUESTION_PAPER: '/questions/questionPaperVersion',
        REPUBLISH_QUESTION_PAPER: '/question-paper/republish',
        UPDATE_PUBLISHED_PAPER: '/question-paper/edit-question',
        QUESTION_UPDATE_REVIEW: '/question-review',
        GET_QUESTIONS_AUTOMATED_IMPORT: '/questions/automated-selection',
        VALIDATE_VERSION: '/question-paper/validate-version',
        GET_QUESTION_MASTER: '/getQuestionMaster',
        SEND_ACCESS_CODE: '/assessments/sendAcessCode'
    },
    NOTIFICATIONS: {
        GET_NOTIFICATIONS_BY_EVENT_IDS: '/notifications/event-ids',
        GET_NOTIFICATION_COUNT: '/notifications/count',
        GET_ALL_NOTIFICATIONS: '/notifications',
        MARK_AS_READ: '/notifications/mark-as-read',
        NOTIFICATION_SETTINGS: '/notifications/settings',
        NOTIFICATIONS_EVENTS: '/notifications/events'
    },
    FINANCE: {
        RATE_MASTER: '/rate-master',
        INVOICES: '/invoices',
        BILLING_ADDRESS: '/billing-address',
        RECEIPTS: '/receipts',
        BILLS: '/bills',
        PAYMENTS: '/payments'
    },
    OPERATIONS: {
        RescheduleAssessment: '/rescheduleAssessment',
        CLONE_ASSESSMENT: '/clone',
        PROJECTS: '/projects',
        CANDIDATES: '/candidates',
        CANDIDATE_ADMIT_CARD: '/assessments/admitCardDetails',
        SEND_ADMIT_CARD_EMAIL: '/assessments/sendAdmitCardEmail',
        ASSESSMENT: '/assessments',
        REPUBLISH: '/assessments/republish/qpv/',
        EXECUTE: '/candidates/stakeholders/token',
        GET_STAKEHOLDERS: '/getAllStakeholders',
    },
    ANALYSIS: {
        COURSE_GROUPS: '/getCourseGroupsByOrgId',
        COURSE_SUBGROUPS: '/getCourseSubGroupsByCourseGroupsId',
        COURSES_BY_IDS: '/getCoursesByIds',
        COURSESVERSION_BY_IDS: '/getCoursesVersionByIds',
        COURSECONSTITUENTS_BY_IDS: '/getCourseConstituentsByIds',
        CONTENT_ANALYSIS: '/getContentAnalysis',
        CONTENT_PAPERS_ANALYSIS: '/getContentPapersAnalysis',
        get_Courses_VersionBy_Detail_Id: '/getCoursesVersionByDetailId',
        ASSESSMENT_ANALYSIS: '/getAssessmentAnalysis',
        CANDIDATE_ANALYSIS: '/getCandidateAnalysis',
        INVOICE_ANALYSIS: '/getInvoiceAnalysis',
        BILLS_ANALYSIS: '/getBillAnalysis'
    },

    COMMENT: {
        GET_COMMENTS: '/getComments',
        GET_REACTIONS: '/getReactions',
        ADD_COMMENT: '/addComment',
        ADD_REPLY: '/addReply',
        ADD_REACTION: '/addReaction',
        DELETE_COMMENT: '/deleteComment'
    },
    SUPPORT_CHAT: {
        CONVERSATIONS: '/supportChat/conversations',
        MESSAGES: '/supportChat/messages',
        SEND_MESSAGE: '/supportChat/sendMessage',
        SEND_INVITE: '/supportChat/sendInvite',
        CHECK_ACCESS: '/supportChat/checkAccess',
        FAQS: '/supportChat/faqs',
        DELETE_MESSAGE: '/supportChat/deleteMessage',
        MARK_READ: '/supportChat/markRead',
        MARK_UNREAD: '/supportChat/markUnread'
    },
    SUPPORT_BOT: {
        START: '/supportBot/start',
        MESSAGE: '/supportBot/message',
        END: '/supportBot/end'
    },
    INBOUND_API: {
        DATA_INTEGRATION: '/bulk-ingest',
        DATA_MAPPING: '/data-mapping',
        UPDATE_STATUS: '/data-mapping/updateStatus/'
    },
    API_CLIENT: '/api/api-client',

}

